








var jspb=require('google-protobuf');
var goog=jspb;
var global=Function('return this')();

var mti_store_cable_state_pb=require('../../../mti/store/cable/state_pb.js');
goog.exportSymbol('proto.mti.store.core_iii.CoreIIIPortStatus',null,global);











proto.mti.store.core_iii.CoreIIIPortStatus=function(opt_data){
jspb.Message.initialize(this,opt_data,0,-1,null,null);
};
goog.inherits(proto.mti.store.core_iii.CoreIIIPortStatus,jspb.Message);
if(goog.DEBUG&&!COMPILED){
proto.mti.store.core_iii.CoreIIIPortStatus.displayName='proto.mti.store.core_iii.CoreIIIPortStatus';
}


if(jspb.Message.GENERATE_TO_OBJECT){










proto.mti.store.core_iii.CoreIIIPortStatus.prototype.toObject=function(opt_includeInstance){
return proto.mti.store.core_iii.CoreIIIPortStatus.toObject(opt_includeInstance,this);
};











proto.mti.store.core_iii.CoreIIIPortStatus.toObject=function(includeInstance,msg){
var f,obj={
primaryDeviceConnected:jspb.Message.getFieldWithDefault(msg,1,false),
secondaryDeviceConnected:jspb.Message.getFieldWithDefault(msg,2,false),
charging:jspb.Message.getFieldWithDefault(msg,3,false),
armed:jspb.Message.getFieldWithDefault(msg,4,false),
primaryDeviceAlarming:jspb.Message.getFieldWithDefault(msg,5,false),
secondaryDeviceAlarming:jspb.Message.getFieldWithDefault(msg,6,false),
overCurrent:jspb.Message.getFieldWithDefault(msg,7,false),
lifted:jspb.Message.getFieldWithDefault(msg,8,false),
cableType:jspb.Message.getFieldWithDefault(msg,9,0),
cableSerialNumber:jspb.Message.getFieldWithDefault(msg,10,""),
cableModelNumber:jspb.Message.getFieldWithDefault(msg,11,""),
cableVersion:jspb.Message.getFieldWithDefault(msg,12,"")};


if(includeInstance){
obj.$jspbMessageInstance=msg;
}
return obj;
};
}







proto.mti.store.core_iii.CoreIIIPortStatus.deserializeBinary=function(bytes){
var reader=new jspb.BinaryReader(bytes);
var msg=new proto.mti.store.core_iii.CoreIIIPortStatus();
return proto.mti.store.core_iii.CoreIIIPortStatus.deserializeBinaryFromReader(msg,reader);
};









proto.mti.store.core_iii.CoreIIIPortStatus.deserializeBinaryFromReader=function(msg,reader){
while(reader.nextField()){
if(reader.isEndGroup()){
break;
}
var field=reader.getFieldNumber();
switch(field){
case 1:
var value=reader.readBool();
msg.setPrimaryDeviceConnected(value);
break;
case 2:
var value=reader.readBool();
msg.setSecondaryDeviceConnected(value);
break;
case 3:
var value=reader.readBool();
msg.setCharging(value);
break;
case 4:
var value=reader.readBool();
msg.setArmed(value);
break;
case 5:
var value=reader.readBool();
msg.setPrimaryDeviceAlarming(value);
break;
case 6:
var value=reader.readBool();
msg.setSecondaryDeviceAlarming(value);
break;
case 7:
var value=reader.readBool();
msg.setOverCurrent(value);
break;
case 8:
var value=reader.readBool();
msg.setLifted(value);
break;
case 9:
var value=reader.readEnum();
msg.setCableType(value);
break;
case 10:
var value=reader.readString();
msg.setCableSerialNumber(value);
break;
case 11:
var value=reader.readString();
msg.setCableModelNumber(value);
break;
case 12:
var value=reader.readString();
msg.setCableVersion(value);
break;
default:
reader.skipField();
break;}

}
return msg;
};






proto.mti.store.core_iii.CoreIIIPortStatus.prototype.serializeBinary=function(){
var writer=new jspb.BinaryWriter();
proto.mti.store.core_iii.CoreIIIPortStatus.serializeBinaryToWriter(this,writer);
return writer.getResultBuffer();
};









proto.mti.store.core_iii.CoreIIIPortStatus.serializeBinaryToWriter=function(message,writer){
var f=undefined;
f=message.getPrimaryDeviceConnected();
if(f){
writer.writeBool(
1,
f);

}
f=message.getSecondaryDeviceConnected();
if(f){
writer.writeBool(
2,
f);

}
f=message.getCharging();
if(f){
writer.writeBool(
3,
f);

}
f=message.getArmed();
if(f){
writer.writeBool(
4,
f);

}
f=message.getPrimaryDeviceAlarming();
if(f){
writer.writeBool(
5,
f);

}
f=message.getSecondaryDeviceAlarming();
if(f){
writer.writeBool(
6,
f);

}
f=message.getOverCurrent();
if(f){
writer.writeBool(
7,
f);

}
f=message.getLifted();
if(f){
writer.writeBool(
8,
f);

}
f=message.getCableType();
if(f!==0.0){
writer.writeEnum(
9,
f);

}
f=message.getCableSerialNumber();
if(f.length>0){
writer.writeString(
10,
f);

}
f=message.getCableModelNumber();
if(f.length>0){
writer.writeString(
11,
f);

}
f=message.getCableVersion();
if(f.length>0){
writer.writeString(
12,
f);

}
};








proto.mti.store.core_iii.CoreIIIPortStatus.prototype.getPrimaryDeviceConnected=function(){
return jspb.Message.getFieldWithDefault(this,1,false);
};



proto.mti.store.core_iii.CoreIIIPortStatus.prototype.setPrimaryDeviceConnected=function(value){
jspb.Message.setProto3BooleanField(this,1,value);
};








proto.mti.store.core_iii.CoreIIIPortStatus.prototype.getSecondaryDeviceConnected=function(){
return jspb.Message.getFieldWithDefault(this,2,false);
};



proto.mti.store.core_iii.CoreIIIPortStatus.prototype.setSecondaryDeviceConnected=function(value){
jspb.Message.setProto3BooleanField(this,2,value);
};








proto.mti.store.core_iii.CoreIIIPortStatus.prototype.getCharging=function(){
return jspb.Message.getFieldWithDefault(this,3,false);
};



proto.mti.store.core_iii.CoreIIIPortStatus.prototype.setCharging=function(value){
jspb.Message.setProto3BooleanField(this,3,value);
};








proto.mti.store.core_iii.CoreIIIPortStatus.prototype.getArmed=function(){
return jspb.Message.getFieldWithDefault(this,4,false);
};



proto.mti.store.core_iii.CoreIIIPortStatus.prototype.setArmed=function(value){
jspb.Message.setProto3BooleanField(this,4,value);
};








proto.mti.store.core_iii.CoreIIIPortStatus.prototype.getPrimaryDeviceAlarming=function(){
return jspb.Message.getFieldWithDefault(this,5,false);
};



proto.mti.store.core_iii.CoreIIIPortStatus.prototype.setPrimaryDeviceAlarming=function(value){
jspb.Message.setProto3BooleanField(this,5,value);
};








proto.mti.store.core_iii.CoreIIIPortStatus.prototype.getSecondaryDeviceAlarming=function(){
return jspb.Message.getFieldWithDefault(this,6,false);
};



proto.mti.store.core_iii.CoreIIIPortStatus.prototype.setSecondaryDeviceAlarming=function(value){
jspb.Message.setProto3BooleanField(this,6,value);
};








proto.mti.store.core_iii.CoreIIIPortStatus.prototype.getOverCurrent=function(){
return jspb.Message.getFieldWithDefault(this,7,false);
};



proto.mti.store.core_iii.CoreIIIPortStatus.prototype.setOverCurrent=function(value){
jspb.Message.setProto3BooleanField(this,7,value);
};








proto.mti.store.core_iii.CoreIIIPortStatus.prototype.getLifted=function(){
return jspb.Message.getFieldWithDefault(this,8,false);
};



proto.mti.store.core_iii.CoreIIIPortStatus.prototype.setLifted=function(value){
jspb.Message.setProto3BooleanField(this,8,value);
};






proto.mti.store.core_iii.CoreIIIPortStatus.prototype.getCableType=function(){
return jspb.Message.getFieldWithDefault(this,9,0);
};



proto.mti.store.core_iii.CoreIIIPortStatus.prototype.setCableType=function(value){
jspb.Message.setProto3EnumField(this,9,value);
};






proto.mti.store.core_iii.CoreIIIPortStatus.prototype.getCableSerialNumber=function(){
return jspb.Message.getFieldWithDefault(this,10,"");
};



proto.mti.store.core_iii.CoreIIIPortStatus.prototype.setCableSerialNumber=function(value){
jspb.Message.setProto3StringField(this,10,value);
};






proto.mti.store.core_iii.CoreIIIPortStatus.prototype.getCableModelNumber=function(){
return jspb.Message.getFieldWithDefault(this,11,"");
};



proto.mti.store.core_iii.CoreIIIPortStatus.prototype.setCableModelNumber=function(value){
jspb.Message.setProto3StringField(this,11,value);
};






proto.mti.store.core_iii.CoreIIIPortStatus.prototype.getCableVersion=function(){
return jspb.Message.getFieldWithDefault(this,12,"");
};



proto.mti.store.core_iii.CoreIIIPortStatus.prototype.setCableVersion=function(value){
jspb.Message.setProto3StringField(this,12,value);
};


goog.object.extend(exports,proto.mti.store.core_iii);